import { Spinner } from '@/components/ui/Spinner'

import styles from './PageLoader.module.css'

/** Route-level fallback while a lazy chunk loads. */
export function PageLoader() {
  return (
    <div className={styles.wrapper}>
      <Spinner size="lg" label="Loading page" />
    </div>
  )
}
